import React, {FC} from 'react';
import {observer} from "mobx-react";
import {Checkbox, Typography} from "@mui/material";
import {useStorageUserConfigContext} from "@app/modules/UserConfig/contexts/storage";
import {Stack} from "@mui/system";
import {CheckboxBase} from "@app/components/CheckboxBase/CheckboxBase";


type TProps = {}

export const CanSaveTranslation: FC<TProps> = observer((props: TProps) => {

    const {userConfigStore} = useStorageUserConfigContext()

    return (
        <CheckboxBase
            description={'Permission to confirm translation'}
            disabled={!userConfigStore.isDisabled}
            checked={userConfigStore.canSaveTranslation}
            onChange={() => userConfigStore.handleChange()}
            value={userConfigStore.isDisabled}
        />
    )

})

